document.addEventListener('DOMContentLoaded', function () {
  const instructorActionLinks = document.querySelectorAll('.instructor-actions .action-card .custom-link-anchor');

  if (instructorActionLinks?.length === 0) {
    return;
  } else {
    instructorActionLinks.forEach(function (link) {
      link.addEventListener('keydown', handleKeydown);
    });
  }
});

function handleKeydown(event) {
  if ((event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') && !event.repeat) {
    event.preventDefault();
    event.target.click();
  }
}
